import React, { useMemo } from 'react';
import styles from './CurrentSessionStatus.module.scss';
import { Button, Icon } from '@mui/material';
import { ISession } from '../../../../modules/session/domain/ISession';
import { IDevice } from '../../../../modules/device/interface/Device';
import { OperatorPermissions } from '../../../../modules/operator/domains/models/Permissions';
import { useI18n } from '../../../../hooks/useI18n';

interface ICurrentSessionStatusProps {
    device?: IDevice;
    currentSession?: ISession;
    onSubmitRemoveSession: () => void;
    onSubmitCloseSessionPassword: () => void;
    onClickGoToCatalog: () => void;
    hasPermission: (Permissions: OperatorPermissions) => boolean;
}
export const CurrentSessionStatus: React.FC<ICurrentSessionStatusProps> = ({ onSubmitRemoveSession, onSubmitCloseSessionPassword, device, currentSession, onClickGoToCatalog, hasPermission }) => {

    const { t } = useI18n();
    const hasPermissionCloseSession = useMemo(() => hasPermission(OperatorPermissions.CLOSE_SESSION), [hasPermission]);

    return <div id={styles.CurrentSessionStatus}>
        {/* <KeyboardInput inputRef={operatorInputRef} password error={error} label={'Senha do operador'} /> */}
        <h2>{t('session.cashierOpen')}</h2>
        {device && <p>{t('session.location')} {device.localName}</p>}
        {device && <p>{t('session.device')} {device?.deviceName}</p>}
        {currentSession?.openedAt && <p>{t('session.openedAt')} {currentSession?.openedAt.toLocaleString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        })}</p>}
        <Button onClick={onClickGoToCatalog} fullWidth variant={'contained'} size='large'><Icon>restaurant</Icon>{t('session.goToCatalog')}</Button>
        <div className={styles.buttonContainer}>
            {/* {hasPermission(OperatorPermissions.LOGOUT_SESSION) && */}
            <Button onClick={onSubmitRemoveSession} fullWidth variant={'outlined'} size='large'>
                {/* <Icon fontSize='small'>logout</Icon> */}
                {t('session.exit')}
            </Button>
            {/*} */}
            {hasPermissionCloseSession &&
                <Button onClick={onSubmitCloseSessionPassword} fullWidth variant={'outlined'} size='large'>
                    {/* <Icon fontSize='small'>logout</Icon> */}
                    {t('session.close')}
                </Button>}
        </div>
    </div>;
};
